(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/best-bet-rows/assets/javascripts/single-row.js') >= 0) return;  svs.modules.push('/components/tipsen/best-bet-rows/assets/javascripts/single-row.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const ButtonBet = svs.ui.ReactButtonBet;
const signIndexToOutcome = svs.components.sport.tipsenShared.signIndexToOutcome;
const useBranding = svs.components.tipsen.hooks.useBranding;
const SingleRow = React.memo(_ref => {
  let row = _ref.row,
    topic = _ref.topic,
    drawResultOutcomes = _ref.drawResultOutcomes,
    eventTypeId = _ref.eventTypeId,
    className = _ref.className;
  const _useBranding = useBranding(),
    _useBranding2 = _slicedToArray(_useBranding, 1),
    productBranding = _useBranding2[0];
  return React.createElement("div", {
    className: ['pg_best_bet_rows__row'].concat(className || []).join(' ')
  }, React.createElement("div", {
    className: "pg_best_bet_rows__row_topic"
  }, topic), React.createElement("div", {
    className: "pg_best_bet_rows__row_outcomes"
  }, row.map((outcome, index) => {
    var _drawResultOutcomes$i;
    return React.createElement(ButtonBet, {
      branding: productBranding,
      className: "pg_best_bet_rows__row_outcome"
      ,
      key: "".concat(outcome).concat(index),
      label: signIndexToOutcome[eventTypeId][outcome[0]],
      selected: outcome[0] === (drawResultOutcomes === null || drawResultOutcomes === void 0 || (_drawResultOutcomes$i = drawResultOutcomes[index]) === null || _drawResultOutcomes$i === void 0 ? void 0 : _drawResultOutcomes$i[0]),
      size: "100"
    });
  })));
}, (prevProps, nextProps) => prevProps.row.join('') === nextProps.row.join('') && prevProps.drawResultOutcomes.join('') === nextProps.drawResultOutcomes.join('') && prevProps.topic === nextProps.topic && prevProps.className === nextProps.className);
setGlobal('svs.tipsen.components.bestBetRows.SingleRow', SingleRow);

 })(window);